import React from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { contactInfoSchema } from '../../services/validationSchemas';
import './Steps.css';

// Ciudades disponibles para JAMA
const AVAILABLE_CITIES = [
  { id: 1, name: 'Ibarra' },
];

const DEFAULT_CITY_ID = AVAILABLE_CITIES[0].id;

const StepContactInfo = ({ formData, onUpdate, onNext, onBack }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    resolver: zodResolver(contactInfoSchema),
    defaultValues: {
      phone: formData.phone || '',
      email: formData.email || '',
      city_id: formData.city_id || DEFAULT_CITY_ID,
    },
    mode: 'onChange',
  });

  const onSubmit = (data) => {
    onUpdate({ ...data, city_id: DEFAULT_CITY_ID });
    onNext();
  };

  return (
    <div className="step-container">
      <div className="step-header">
        <span className="step-icon">📱</span>
        <h2 className="step-title">Información de Contacto</h2>
        <p className="step-subtitle">
          Necesitamos tus datos de contacto para comunicarnos contigo
        </p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="step-form">
        <div className="form-group">
          <label htmlFor="phone">Número de Teléfono</label>
          <input
            id="phone"
            type="tel"
            placeholder="Ej: 0991234567"
            className={errors.phone ? 'error' : ''}
            {...register('phone')}
          />
          {errors.phone && (
            <span className="error-message">{errors.phone.message}</span>
          )}
          <span className="input-hint">Número de WhatsApp preferiblemente</span>
        </div>

        <div className="form-group">
          <label htmlFor="email">Correo Electrónico</label>
          <input
            id="email"
            type="email"
            placeholder="Ej: tu@email.com"
            className={errors.email ? 'error' : ''}
            {...register('email')}
          />
          {errors.email && (
            <span className="error-message">{errors.email.message}</span>
          )}
        </div>

        <div className="form-group">
          <label>Ciudad donde trabajarás</label>
          <div className="city-fixed">
            <span className="city-fixed__icon">📍</span>
            <span className="city-fixed__name">Ibarra</span>
            <span className="city-fixed__badge">Única ciudad disponible</span>
          </div>
        </div>

        <div className="step-actions">
          <button type="button" className="btn-secondary" onClick={onBack}>
            <span className="btn-arrow">←</span>
            Atrás
          </button>
          <button type="submit" className="btn-primary" disabled={!isValid}>
            Continuar
            <span className="btn-arrow">→</span>
          </button>
        </div>
      </form>
    </div>
  );
};

export default StepContactInfo;
